import React, { ReactNode } from "react";
import styles from '../LinkPersonalizado6/linkPersonalizado6.module.scss';

interface LinkPersonalizado6Props {
    href: string;
    title: string;
    icon: ReactNode;
    colorText: string;
}

const LinkPersonalizado6: React.FC<LinkPersonalizado6Props> = ({
    href,
    title,
    icon,
    colorText,
}) => {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            style={{
                position: "relative",
                background: "linear-gradient(90deg, #FFFFFF, #CEC4AF)",
                padding: "5px 10px",
                borderRadius: "20px",
                textDecoration: "none",
            }}
        >
            <div className={styles["div-icon"]}>{icon}</div>
            <div className="d-flex align-items-center justify-content-center">
                <div className={styles["min-w-span"]}>
                    <span className={styles["span"]} style={{ color: colorText, fontWeight: "bold" }}>{title}</span>
                </div>
            </div>
        </a>
    );
};

export default LinkPersonalizado6;
